<template>
  <div class="to-pup-page">
    <div class="user-info">
      <div class="user-info-title">
        <span>用户信息</span>
      </div>
      <div class="user-info-list">
        <a-row>
          <a-col :span="6">
            <span class="list-name">微信昵称：</span>
            <span class="list-value">{{ userInfo.nickname }}</span>
          </a-col>
          <a-col :span="6">
            <span class="list-name">微信号：</span>
            <span class="list-value">{{ userInfo.nickname }}</span>
          </a-col>
          <a-col :span="6">
            <span class="list-name">是否绑定微信号：</span>
            <span class="list-value">{{ userInfo.nickname }}</span>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="6">
            <span class="list-name">手机号：</span>
            <span class="list-value">{{ userInfo.mobile }}</span>
          </a-col>
          <a-col :span="6">
            <span class="list-name">邀请码：</span>
            <span class="list-value">{{ userInfo.nickname }}</span>
          </a-col>
          <a-col :span="6">
            <span class="list-name">账户零钱：</span>
            <span class="list-value">{{ userInfo.inviteCode }}</span>
          </a-col>
        </a-row>
      </div>
    </div>
    <div class="top-up-info">
      <div class="top-up-info-title">
        <span>充值信息</span>
      </div>
      <div class="top-up-info-list">
        <div class="top-up-info-left">
          <a-row>
            <a-col :span="5" class="list-name">
              <span>编号：</span>
            </a-col>
            <a-col :span="15">
              <a-input placeholder="请填写编号" />
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="5" class="list-name">
              <span>单位名称：</span>
            </a-col>
            <a-col :span="15">
              <a-input placeholder="请填写单位名称" />
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="5" class="list-name">
              <span>银行：</span>
            </a-col>
            <a-col :span="15">
              <a-input placeholder="请填写银行名称" />
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="5" class="list-name">
              <span>联系人：</span>
            </a-col>
            <a-col :span="15">
              <a-input placeholder="请填写联系人" />
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="5" class="list-name">
              <span>区域：</span>
            </a-col>
            <a-col :span="15">
              <a-input placeholder="Basic usage" />
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="5" class="list-name">
              <span>回执单：</span>
            </a-col>
            <a-col :span="15">
              <a-input placeholder="Basic usage" />
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="4" class="list-name">
              <span>备注：</span>
            </a-col>
            <a-col :span="15">
              <a-input placeholder="Basic usage" />
            </a-col>
          </a-row>
        </div>
        <div class="top-up-info-left">
          <a-row>
            <a-col :span="5" class="list-name">
              <span>日期：</span>
            </a-col>
            <a-col :span="15">
              <a-input placeholder="Basic usage" />
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="5" class="list-name">
              <span>银行账户：</span>
            </a-col>
            <a-col :span="15">
              <a-input placeholder="请填写银行账户" />
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="5" class="list-name">
              <span>充值金额：</span>
            </a-col>
            <a-col :span="15">
              <a-input placeholder="Basic usage" />
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="5" class="list-name">
              <span>联系方式：</span>
            </a-col>
            <a-col :span="15">
              <a-input placeholder="请填写联系方式" />
            </a-col>
          </a-row>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getMemberInfoByStoreId } from "@/utils/api";
export default {
  data() {
    return {
      userInfo: {},
    };
  },
  mounted() {
    this.getMemberInfo();
  },
  methods: {
    getMemberInfo() {
      let params = {},
        header = {},
        data = {
          memberId: this.$route.query.id,
        };

      getMemberInfoByStoreId(params, header, data).then((res) => {
        if (res.code == 200) {
          console.log(res);
          this.userInfo = res.result;
        }
      });
    },
  },
};
</script>

<style lang="scss">
.to-pup-page {
  padding: 24px 0;
  .user-info {
    box-shadow: 0px 0px 5px #ccc;
    padding: 24px;
    border-radius: 5px;
    background-color: #ffffff;
    .user-info-title {
      font-size: 20px;
      font-weight: bold;
      padding-bottom: 15px;
    }
    .user-info-list {
      padding: 0 24px;
    }
    .ant-row {
      display: flex;
      padding: 15px 0;
    }
  }
  .top-up-info {
    box-shadow: 0px 0px 5px #ccc;
    padding: 24px;
    border-radius: 5px;
    background-color: #ffffff;
    margin-top: 24px;
    .top-up-info-title {
      font-size: 20px;
      font-weight: bold;
      padding-bottom: 15px;
    }
    .top-up-info-list {
      padding: 0 24px;
      display: flex;
      .top-up-info-left {
        width: 40%;
      }
      .top-up-info-right {
        width: 40%;
        height: 100%;
      }
      .list-name {
        text-align: right;
      }
    }
    .ant-row {
      display: flex;
      padding: 15px 0;
    }
  }
}
</style>